<script setup>
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { BForm, BButton } from 'bootstrap-vue-next';
  import AdvancedSearchCriteria from './advanced_search/AdvancedSearchCriteria.vue';

  // The other props (the criteria options and initial values) go through to the criteria
  defineOptions({ inheritAttrs: false });

  const { t } = useI18n();

  const props = defineProps({
    // Address of the advanced search without criteria
    reset_url: {
      type: String,
      required: false,
      default: '/advanced_search'
    }
  });

  const criteria = ref(null);

  const onSubmit = () => {
    window.location.href = '/search?' + criteria.value.query;
  };
</script>

<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        <BForm @submit="onSubmit">
          <AdvancedSearchCriteria ref="criteria" v-bind="$attrs" />

          <div class="mt-3">
            <BButton type="submit" variant="primary">{{ t('advanced_search.submit') }}</BButton>
            <!-- Reloads the page without its URL parameters, so every field gets back its default value -->
            <a :href="props.reset_url" class="btn btn-outline-secondary ms-2">{{ t('advanced_search.reset') }}</a>
          </div>
        </BForm>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  :deep() {
    @import '../../../node_modules/bootstrap/scss/bootstrap.scss';
    @import '../../../node_modules/bootstrap-vue-next/dist/bootstrap-vue-next';
  }
</style>

<i18n src="../locales/en.json" global></i18n>
<i18n src="../locales/fr.json" global></i18n>
<i18n src="../locales/es.json" global></i18n>
<i18n src="../locales/it.json" global></i18n>
<i18n src="../locales/pt.json" global></i18n>
<i18n src="../locales/de.json" global></i18n>
